<template>
    <div class="bestsellers">
        <div class="bestseller-slider">
            <h3 class="def-header-3">{{result.messages.title}}</h3>
            <div class="bestseller-slider__link">
                <a :href="result.link.href" class="def-link">{{result.link.name}}</a>
            </div>
            <DefSliderWrapper>
                <swiper
                    :modules="modules"
                    :slides-per-view="1"
                    :pagination="{ clickable: true }"
                    navigation
                >
                    <swiper-slide
                        v-for="(item, i) in result.items"
                        :key="i"
                    >
                        <product-card-2 :result="item" />
                    </swiper-slide>
                </swiper>
            </DefSliderWrapper>
        </div>
        <div v-if="screenWidth >= 768" class="bestsellers__banner" :style="`background-image: url(${'/local/templates/love-you/images/front-end/bestsellers.png'})`">
<!--            <img src="/local/templates/love-you/images/front-end/bestsellers.png" alt="bestsellers">-->
        </div>
    </div>
</template>

<script>
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
    name: 'Bestsellers',
    selector: '.bestsellers',
    props: {
        result: {
            type: Object,
            default: () => ({
                items: [
                    {
                        "id": 52612,
                        "name": "Браслет з білого золота з діамантами: 421650120201",
                        "detailPage": "/catalog/test/braslet-iz-belogo-zolota-s-brilliantami-artikul-421650120201/",
                        "detailText": {
                            "TYPE": "HTML",
                            "TEXT": "Надеть Серьги из белого золота Dress code с бриллиантами. Артикул: 219102820201 - это как выиграть лотерею, при чем дважды. Синий бриллиант сулит яркую жизнь, уверенность в себе и обилие жизненных сил. В то время как черный обладает решительностью, активностью и выдержкой. Обещаем, что будете выходить победительницей из сложных ситуаций хотя бы потому, что с коллекцией Dress code легко выбрать украшение на все случаи жизни. Переливами разноцветных камней мы создаем обворожительную атмосферу вокруг наших изделий и их владелиц."
                        },
                        "article": 52612,
                        "price": {"price": 0, "printPrice": "0 грн."},
                        "offer": {"id": 57663, "price": {"price": 0, "printPrice": "0 грн."}, "current": true},
                        "offers": [{"id": 57663, "price": {"price": 0, "printPrice": "0 грн."}, "current": true}, {
                            "id": 57066,
                            "price": {"price": 0, "printPrice": "0 грн."},
                            "current": false
                        }, {"id": 57065, "price": {"price": 0, "printPrice": "0 грн."}, "current": false}, {
                            "id": 57064,
                            "price": {"price": 0, "printPrice": "0 грн."},
                            "current": false
                        }, {"id": 57063, "price": {"price": 71918, "printPrice": "71918 грн."}, "current": false}],
                        "propsForCheck": [],
                        "attributes": {"id": "bx_3966226736_52612"},
                        "picture": {
                            "alt": "Браслет з білого золота з діамантами: 421650120201",
                            "src": "/upload/resize_cache/iblock/815/200_200_140cd750bba9870f18aada2478b24840a/815c98274d95fd3c2ddaa9446baad3b8.jpg"
                        },
                        "buyPath": "/ajax/?id=57663&action=addToBasket"
                    },
                    {
                        "id": 52612,
                        "name": "Браслет з білого золота з діамантами: 421650120201",
                        "detailPage": "/catalog/test/braslet-iz-belogo-zolota-s-brilliantami-artikul-421650120201/",
                        "detailText": {
                            "TYPE": "HTML",
                            "TEXT": "Надеть Серьги из белого золота Dress code с бриллиантами. Артикул: 219102820201 - это как выиграть лотерею, при чем дважды. Синий бриллиант сулит яркую жизнь, уверенность в себе и обилие жизненных сил. В то время как черный обладает решительностью, активностью и выдержкой. Обещаем, что будете выходить победительницей из сложных ситуаций хотя бы потому, что с коллекцией Dress code легко выбрать украшение на все случаи жизни. Переливами разноцветных камней мы создаем обворожительную атмосферу вокруг наших изделий и их владелиц."
                        },
                        "article": 52612,
                        "price": {"price": 0, "printPrice": "0 грн."},
                        "offer": {"id": 57663, "price": {"price": 0, "printPrice": "0 грн."}, "current": true},
                        "offers": [{"id": 57663, "price": {"price": 0, "printPrice": "0 грн."}, "current": true}, {
                            "id": 57066,
                            "price": {"price": 0, "printPrice": "0 грн."},
                            "current": false
                        }, {"id": 57065, "price": {"price": 0, "printPrice": "0 грн."}, "current": false}, {
                            "id": 57064,
                            "price": {"price": 0, "printPrice": "0 грн."},
                            "current": false
                        }, {"id": 57063, "price": {"price": 71918, "printPrice": "71918 грн."}, "current": false}],
                        "propsForCheck": [],
                        "attributes": {"id": "bx_3966226736_52612"},
                        "picture": {
                            "alt": "Браслет з білого золота з діамантами: 421650120201",
                            "src": "/upload/resize_cache/iblock/815/200_200_140cd750bba9870f18aada2478b24840a/815c98274d95fd3c2ddaa9446baad3b8.jpg"
                        },
                        "buyPath": "/ajax/?id=57663&action=addToBasket"
                    },
                ],
                messages: {
                    title: 'Бестселлери'
                },
                link: {
                    name: 'До каталогу',
                    href: 'javascript: void(0)'
                }
            })
        },
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            modules: [Navigation, Pagination],
        }
    },
}
</script>

<style lang="scss">
    .bestsellers{
        display: flex;
        max-width: 100%;
        margin: 50px 0;
        @include point-md{
            margin: 80px 0;
        }
        @include point-lg{
            margin: 104px 0;
        }
        &__banner{
            background-repeat: no-repeat;
            background-position: top;
            width: 50%;
            img{
                display: block;
                max-width: 100%;
            }
        }

    }
    .bestseller-slider{
        background-color: #fff;
        padding: 48px 0;
        width: 100%;
        @include point-md{
            width: 50%;
            padding: 40px 0;
        }
        @include point-lg{
            padding: 64px 0;
        }
        .slider-wrapper{
            max-width: 250px;
            margin-left: auto;
            margin-right: auto;
            @include point-lg{
                max-width: 400px;
            }
        }
        .def-header-3{
            max-width: 400px;
            margin: 0 auto 8px;
        }
        &__link{
            display: flex;
            align-items: center;
            justify-content: center;
            max-width: 400px;
            margin: 0 auto 24px;
            @include point-lg{
                margin: 0 auto 40px;
            }
            .def-link{
                font-weight: 500;
                font-size: rem(16);
                color: #757575;
            }
        }
    }
</style>